import { render } from "./BackOrder.vue?vue&type=template&id=40ae5b67"
import script from "./BackOrder.vue?vue&type=script&lang=js"
export * from "./BackOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__